import SingleRing, { type SingleRingProps } from './SingleRing';

export type { SingleRingProps };
export default SingleRing;
